import "bootstrap/dist/css/bootstrap.min.css";
import "./css/custom.css";
import "swiper/css";
import "swiper/css/pagination";
import { useLocation, useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
import getRoutes from "./routes";
import { useEffect } from "react";

const App = () => {
  const location = useLocation();
  const localSUser = JSON.parse(localStorage.getItem("user"));
  const { user } = useSelector((state) => state.userReducer);
  const routing = useRoutes(getRoutes(localSUser ? user : null));

  useEffect(() => {
    const path = location.pathname;
    const loginRoute = localStorage.getItem("loginRoute");
    if (path.includes("login")) {
      localStorage.setItem("loginRoute", path);
    } else if (user && !loginRoute) {
      const userRoute = `/${user?.user_role?.toLowerCase()}-login`;
      const defaultRoute =
        user?.user_role === "DM" || user?.user_role === "ADMIN"
          ? userRoute
          : "/login";
      localStorage.setItem("loginRoute", defaultRoute);
    }
  }, [location.pathname, user]);

  return <>{routing}</>;
};

export default App;
